import { render, staticRenderFns } from "./water.vue?vue&type=template&id=a97fe8cc&scoped=true"
import script from "./water.vue?vue&type=script&lang=js"
export * from "./water.vue?vue&type=script&lang=js"
import style0 from "./water.vue?vue&type=style&index=0&id=a97fe8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97fe8cc",
  null
  
)

export default component.exports